import { SYMBOL_LIST } from "@/lib/symbols";

const SOURCE_LABEL = {
  tradingview: "TV REALTIME",
  coinbase: "COINBASE WS",
  yahoo: "YAHOO",
  mt5: "MT5 BROKER",
};

const SourceChip = ({ sig, symbol }) => {
  const updatedAt = sig?.updated_at ? new Date(sig.updated_at).getTime() : 0;
  const ageSec = (Date.now() - updatedAt) / 1000;
  const state = !sig ? "dead" : ageSec < 45 ? "fresh" : ageSec < 120 ? "stale" : "dead";
  const dot = state === "fresh" ? "bg-buy" : state === "stale" ? "bg-warn" : "bg-sell";
  const src = SOURCE_LABEL[sig?.source] || "ENGINE";
  return (
    <span
      className="flex items-center gap-1.5 border border-white/10 bg-ink px-2 py-1"
      data-testid={`source-chip-${symbol.toLowerCase()}`}
      title={sig ? `sumber: ${src} · diperbarui ${Math.round(ageSec)}s lalu` : "belum ada data"}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${dot} ${state === "fresh" ? "animate-pulse" : ""}`} />
      <span className="font-mono text-[9px] font-bold text-white">{symbol}</span>
      <span className={`font-mono text-[8px] ${state === "dead" ? "text-sell" : "text-mute-dim"}`}>
        {state === "dead" ? "MATI" : src}
      </span>
    </span>
  );
};

export const SourceBar = ({ signals }) => (
  <div
    className="mb-3 flex flex-wrap items-center gap-1.5 border border-white/10 bg-[#0d1219] px-3 py-2"
    data-testid="source-bar"
  >
    <span className="mr-1 font-mono text-[9px] uppercase tracking-[0.25em] text-mute-dim">Sumber Data</span>
    {SYMBOL_LIST.map((sym) => (
      <SourceChip key={sym} symbol={sym} sig={signals.find((s) => s.symbol === sym)} />
    ))}
    <span className="ml-auto hidden font-mono text-[8px] text-mute-dim sm:inline">
      prioritas: MT5 → TradingView → Coinbase → Yahoo · hijau=fresh · kuning=lambat · merah=mati
    </span>
  </div>
);
